export default __webpack_public_path__ + "static/media/1_10_logo.7fdc096d.png";